import { Button, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import styled from 'styled-components';

const JSONModal = ({ buttonText, modalHeader, jsonData }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <StyledButton onClick={handleOpen}>{buttonText}</StyledButton>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Wrapper>
                    <Header>
                        <h3>{modalHeader}</h3>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Header>
                    <Content>
                        <pre>{jsonData ? JSON.stringify(jsonData, null, 2) : null}</pre>
                    </Content>
                </Wrapper>
            </Modal>
        </>
    );
};

export default JSONModal;

const Wrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    max-width: 50vw;
    max-height: 80vh;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #e0e0e0;

    h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
    }
`;

const StyledButton = styled(Button)`
    text-transform: none !important;
    color: #5D78FF !important;
    font-size: 14px !important;
    font-weight: 600 !important;
`

const Content = styled.div`
    padding: 16px 20px;
    overflow-y: auto;
    flex: 1;

    pre {
        background: #f8f9fa;
        padding: 12px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 1.4;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
`;
